import React from "react";
import { HashRouter, Route } from "react-router-dom";
import { LearnMore } from "./components/LearnMore/LearnMore";
import { InterruptPage } from "./components/InterruptPage/InterruptPage";
import { ErrorBoundary } from "react-error-boundary";
import { FallbackUI, errorHandlerLearnMore, errorHandlerUCNotice } from "./Utilities/errorBoundaryHelper";

export const Routes: React.FC = () => {

    return (
        < HashRouter >
            <ErrorBoundary FallbackComponent={FallbackUI} onError={errorHandlerUCNotice}>
                <Route component={InterruptPage} path="/" exact={true} />
            </ErrorBoundary>
            <ErrorBoundary FallbackComponent={FallbackUI} onError= {errorHandlerLearnMore}>
                <Route component={LearnMore} path="/learnmore" exact={true} />
            </ErrorBoundary>
        </HashRouter >
    );
};

